import React from 'react'

export default function Chevrons_right() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 9 8" fill="none">
        <path d="M4.63889 6.30556L7.41667 3.52778L4.63889 0.75M0.75 6.30556L3.52778 3.52778L0.75 0.75" stroke="#344054" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}
